import { render, staticRenderFns } from "./TimePeriodDetails.vue?vue&type=template&id=3874372e"
import script from "./TimePeriodDetails.vue?vue&type=script&lang=js"
export * from "./TimePeriodDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports